import types from '../types/index';

const getFinancesUsersCourses = (payload) => ({
  type: types.finances.GET_FINANCES_USER_COURSES,
  payload,
});

const getFinancesUsersTrialCourses = (payload) => ({
  type: types.finances.GET_FINANCES_USER_TRIAL_COURSES,
  payload,
});

const getFinancesError = (payload) => ({
  type: types.finances.GET_FINANCES_ERROR,
  payload,
});

const getFinancesErrorNotFound = (payload) => ({
  type: types.finances.GET_FINANCES_ERROR_404,
  payload,
});

const getFinancesUsersDocuments = (payload) => ({
  type: types.finances.GET_FINANCES_USER_DOCUMENTS,
  payload,
});

const getFinancesDocumentsName = (payload) => ({
  type: types.finances.GET_FINANCES_DOCUMENTS_NAME,
  payload,
});

const getFinancesAccounts = (payload) => ({
  type: types.finances.GET_FINANCES_ACCOUNTS,
  payload
});

const getFinancesStudentButton = (payload) => ({
  type: types.finances.GET_FINANCES_STUDENT_BUTTON_ACCOUNT,
  payload
});

const getFinancesMessage = (payload) => ({
  type: types.finances.GET_FINANCES_MESSAGE,
  payload,
});

const getPayActulInvoice = (payload) => ({
  type: types.finances.GET_PAY_ACTUAL_INVOICE,
  payload,
});

const getPayActulTariffs = (payload) => ({
  type: types.finances.GET_PAY_ACTUAL_TARIFFS,
  payload,
});

const getPaymentsMethods = (payload) => ({
  type: types.finances.GET_PAYMENTS_METHODS,
  payload,
});

const getPaymentLink = (payload) => ({
  type: types.finances.GET_PAYMENT_LINK,
  payload,
});

const getPayDetails = (payload) => ({
  type: types.finances.GET_PAY_DETAILS,
  payload,
});

const getPayPdf = (payload) => ({
  type: types.finances.GET_PAY_PDF,
  payload,
});

const setParamInvoice = (payload) => ({
  type: types.finances.SET_PARAM_INVOICE,
  payload
});

const setParamPaymentUuid = (payload) => ({
  type: types.finances.SET_PARAM_PAYMENT_UUID,
  payload
});

const createCopyPayment = (payload) => ({
  type: types.finances.CREATE_COPY_PAYMENT,
  payload
});

const startFetching = () => ({
  type: types.finances.START_FETCHING_FINANCES
});

const stopFetching = () => ({
  type: types.finances.STOP_FETCHING_FINANCES,
});

const startFetchingBtn = () => ({
  type: types.finances.START_FETCHING_GENERAL_BTN
});

const stopFetchingBtn = () => ({
  type: types.finances.STOP_FETCHING_GENERAL_BTN,
});

const setFullCourseTariff = (payload) => ({
  type: types.finances.SET_FULL_COURSE_TARIFF,
  payload,
});

export default {
  setFullCourseTariff,
  getFinancesUsersCourses,
  getFinancesUsersTrialCourses,
  getFinancesUsersDocuments,
  getFinancesDocumentsName,
  getFinancesAccounts,
  getFinancesStudentButton,
  getPayActulInvoice,
  getPayActulTariffs,
  getPaymentsMethods,
  getPaymentLink,
  getFinancesMessage,
  getPayDetails,
  getPayPdf,
  getFinancesError,
  getFinancesErrorNotFound,
  startFetching,
  stopFetching,
  startFetchingBtn,
  stopFetchingBtn,
  setParamInvoice,
  setParamPaymentUuid,
  createCopyPayment
};